module.exports = __webpack_public_path__ + "img/fortnite.6afe7a58.jpg";